import { PersistanceCanceled } from '@ngrx/data';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const swallowCancellationError =
  <T>(swallow = true) =>
  (source$: Observable<T>) =>
    source$.pipe(catchError(err => (err instanceof PersistanceCanceled && swallow ? EMPTY : throwError(err))));
